export enum ApplicationCategory {
  NewApplication = 'NewApplication',
  UpdateApplication = 'UpdateApplication',
  CancelApplication = 'CancelApplication',
  CancelContract = 'CancelContract',
  Leave = 'Leave'
}
